<template>
  <div class="md-layout" role="banner">
    <div class="md-layout-item md-size-15 logo  md-xsmall-size-30 logoportale">
      <img
        class="customimg logo"
        src="../assets/logo.png"
        aria-hidden="true"
        role="presentation"
        alt="logo uVote"
      /><span v-if="!isMobile" class="portalescrutinio1">{{
        $t("header.counting-portal")
      }}</span>
      <span v-if="isMobile" class="portalescrutinio1">{{
        $t("header.counting")
      }}</span>
    </div>
    <div class="md-layout-item md-size-25  md-xsmall-size-5">
      <!--<div class="portalescrutinio">Portale di scrutinio</div>-->
    </div>
    <div class="md-layout-item md-size-20  md-xsmall-size-30">
      <img
        class="customimg"
        v-bind:src="
          'data:image/jpeg;base64,' +
            $store.state.retIdentification.ElectionEvent.EventLogo.Binary.value
        "
        aria-hidden="true"
        role="presentation"
        :alt="$t('header.event-logo')"
      />
    </div>
    <div class="md-layout-item md-size-20 md-xsmall-size-5">
      <!-- <div class="dropdown">
        <button
          href="#"
          class="btn dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
        >
          {{ $i18n.locale | capitalize }}
        </button> -->
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a
          v-for="(locale, index) in locales"
          :key="index"
          class="dropdown-item language-button"
          href="#"
          @click.prevent="setLocale(locale)"
        >
          {{ locale | capitalize }}
        </a>
      </div>
      <!-- </div> -->
    </div>
    <div
      class="md-layout-item md-size-20 md-xsmall-size-30 logoutportale"
      md-alignment="right"
    >
      <md-button @click="confirmLogout = true" class="md-button logout"
        ><md-tooltip
          v-bind:style="isMobile ? 'display: none;' : ''"
          class="tooltip"
          >{{ $t("header.logout-button") }}</md-tooltip
        >
        <md-icon class="md-size-1x" aria-hidden="true" role="presentation"
          >exit_to_app</md-icon
        >Logout
      </md-button>
      <confirm-logout-dialog
        v-if="confirmLogout"
        :confirmLogout="confirmLogout"
        @cancel="confirmLogout = false"
        @oklogout="logout()"
      >
      </confirm-logout-dialog>
    </div>
  </div>
</template>

<script>
import { isMobile } from "mobile-device-detect";
import ConfirmLogoutDialog from "./ConfirmLogoutDialog";

export default {
  async mounted() {
    this.isMobile = isMobile;
  },
  data: function() {
    return {
      isMobile: false,
      confirmLogout: false,
      locales: process.env.VUE_APP_I18N_SUPPORTED_LOCALE.split(","),
      selectedLang: process.env.VUE_APP_I18N_LOCALE,
      isVisible: false,
      focusedIndex: 0
    };
  },
  props: ["showhelp", "userDisabled", "userName"],
  methods: {
    logout() {
      this.$store.replaceState({});
      this.$keycloak.logoutFn();
    },
    hideDropdown() {
      this.isVisible = false;
      this.focusedIndex = 0;
    },
    setLocale(locale) {
      this.$i18n.locale = locale;
      this.selectedLang = locale;
      this.$store.commit("keycloakLanguageSetter", locale);
      sessionStorage.setItem("currentLanguageSelected", locale);
      this.$router
        .push({
          params: { locale: locale }
        })
        .catch(() => {});
      this.hideDropdown();
    }
  },
  filters: {
    capitalize: function(value) {
      if (!value) return "";
      value = value.toString();
      return value.toUpperCase();
    }
  },
  components: {
    ConfirmLogoutDialog
  }
};
</script>

<style scoped>
html.md-theme-default {
  background-color: #dedddb !important;
  background-color: var(--md-theme-default-background-variant, #dedddb);
}
.custom {
  padding: 5px;
}

.head {
  max-height: 100px;
}

.md-tabs-navigation {
  height: 50px !important;
}

.md-layout.w-header {
  padding: 20px 0;
}
.md-layout-item.md-size-100 {
  min-width: 90% !important;
  max-width: 95% !important;
  margin-left: none;
  flex: 1 1 100%;
  margin: 20px auto !important;
}
.md-layout {
  display: flex;
  flex-wrap: wrap;
  background: #fff !important;
  height: auto !important;
}
.logo {
  padding: 0 0 0 20px !important;
}
.customimg[data-v-88f6691c] {
  max-height: 100%;
  xmax-width: height;
  width: auto;
  height: auto;
  padding: 20px !important;
}
.icon {
  display: block;
  margin: auto;
}
.customimg {
  width: auto;
  height: auto;
}

.customimg.logo {
  width: 50%;
}

.tooltip {
  z-index: 10;
}

.logout {
  margin: 5px 0 0 0;
}

.portalescrutinio {
  font-size: 26px;
  float: left;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: bold;
  margin-top: 4%;
}

.portalescrutinio1 {
  font-size: 14px;
  font-weight: bold;
  display: block;
}

.logoportale {
  float: left;
}

.logoutportale {
  float: right;
}

select {
  width: 25%;
  line-height: 49px;
  height: 23%;
  font-size: 12px;
  outline: 0;
  margin-bottom: 15px;
}

.flag {
  width: 30%;
  height: 10%;
}

.menu-language-flag {
  width: 10%;
}

.dropdown-menu {
  width: 60%;
  float: right;
  position: relative;
  top: 21%;
}

.dropdown-item {
  border-radius: 2.5px;
}

.language-button {
  border: solid 1px rgba(0, 0, 0, 0.54);
  padding: 5%;
  margin: 1%;
  font-size: 14px;
  text-align: center;
}

@media screen and (max-width: 1024px) {
  .customimg.logo {
    width: auto;
  }
}

@media screen and (max-width: 768px) {
  .logout {
    margin-top: -4px;
  }

  .portalescrutinio1 {
    font-size: 12px;
  }
}
</style>
